module.exports = __webpack_public_path__ + "img/world.4436db3f.svg";